<template>
  <el-container class="cloud-com-count">
    <el-header class="header-style">
      <el-divider content-position="left">云上公司注册统计</el-divider>
    </el-header>

    <el-main class="main-style">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <!-- 当前数据统计模块 开始-->
        <el-tab-pane label="当前数据" name="today">
          <el-row :span="24" style="margin: 0.2rem 0">
            <el-col :span="12" style="color: #67c23a; font-size: 18px">
              今日：{{ todayShowDate }}
            </el-col>
          </el-row>
          <el-table
            :data="todayOrderData"
            size="medium"
            border
            style="width: 100%; margin-bottom: 1rem"
            v-cloak
          >
            <el-table-column label="今日订单" width="200">
              <template slot-scope="scope">
                <span class="font-style">{{ scope.row.today_order_total }}</span>
              </template>
            </el-table-column>
            <el-table-column label="合格信息表">
              <template slot-scope="scope">
                <span class="font-style"
                  >今日订单：{{ scope.row.today_info_excel_total.split("/")[0] }}</span
                >
                <br />
                <span class="font-style"
                  >非今日订单：{{ scope.row.today_info_excel_total.split("/")[1] }}</span
                >
                <br />
                <span class="font-style"
                  >总数：{{
                    parseInt(scope.row.today_info_excel_total.split("/")[0]) +
                    parseInt(scope.row.today_info_excel_total.split("/")[1])
                  }}</span
                >
              </template>
            </el-table-column>
            <el-table-column label="今日网报">
              <template slot-scope="scope">
                <span class="font-style"
                  >今日订单：{{ scope.row.today_web_total.split("/")[0] }}</span
                >
                <br />
                <span class="font-style"
                  >非今日订单：{{ scope.row.today_web_total.split("/")[1] }}</span
                >
                <br />
                <span class="font-style"
                  >总数：{{
                    parseInt(scope.row.today_web_total.split("/")[0]) +
                    parseInt(scope.row.today_web_total.split("/")[1])
                  }}</span
                >
              </template>
            </el-table-column>
            <el-table-column label="今日下证">
              <template slot-scope="scope">
                <span class="font-style"
                  >今日订单：{{ scope.row.today_down_cert_total.split("/")[0] }}</span
                >
                <br />
                <span class="font-style"
                  >非今日订单：{{ scope.row.today_down_cert_total.split("/")[1] }}</span
                >
                <br />
                <span class="font-style"
                  >总数：{{
                    parseInt(scope.row.today_down_cert_total.split("/")[0]) +
                    parseInt(scope.row.today_down_cert_total.split("/")[1])
                  }}</span
                >
              </template>
            </el-table-column>
          </el-table>
          <el-row :span="24" style="margin: 0.2rem 0">
            <el-col :span="12" style="color: #67c23a; font-size: 18px">
              本周：{{ weekShowDate }}
            </el-col>
          </el-row>
          <el-table
            :data="weekOrderData"
            size="medium"
            border
            style="width: 100%; margin-bottom: 1rem"
            v-cloak
          >
            <el-table-column label="本周订单" width="200">
              <template slot-scope="scope">
                <span class="font-style">{{ scope.row.week_order_total }}</span>
              </template>
            </el-table-column>
            <el-table-column label="本周合格信息表">
              <template slot-scope="scope">
                <span class="font-style"
                  >本周订单：{{ scope.row.week_info_excel_total.split("/")[0] }}</span
                >
                <br />
                <span class="font-style"
                  >非本周订单：{{ scope.row.week_info_excel_total.split("/")[1] }}</span
                >
                <br />
                <span class="font-style"
                  >总数：{{
                    parseInt(scope.row.week_info_excel_total.split("/")[0]) +
                    parseInt(scope.row.week_info_excel_total.split("/")[1])
                  }}</span
                >
              </template>
            </el-table-column>
            <el-table-column label="本周网报">
              <template slot-scope="scope">
                <span class="font-style"
                  >本周订单：{{ scope.row.week_web_total.split("/")[0] }}</span
                >
                <br />
                <span class="font-style"
                  >非本周订单：{{ scope.row.week_web_total.split("/")[1] }}</span
                >
                <br />
                <span class="font-style"
                  >总数：{{
                    parseInt(scope.row.week_web_total.split("/")[0]) +
                    parseInt(scope.row.week_web_total.split("/")[1])
                  }}</span
                >
              </template>
            </el-table-column>
            <el-table-column label="本周下证">
              <template slot-scope="scope">
                <span class="font-style"
                  >本周订单：{{ scope.row.week_down_cert_total.split("/")[0] }}</span
                >
                <br />
                <span class="font-style"
                  >非本周订单：{{ scope.row.week_down_cert_total.split("/")[1] }}</span
                >
                <br />
                <span class="font-style"
                  >总数：{{
                    parseInt(scope.row.week_down_cert_total.split("/")[0]) +
                    parseInt(scope.row.week_down_cert_total.split("/")[1])
                  }}</span
                >
              </template>
            </el-table-column>
          </el-table>
          <el-row :span="24" style="margin: 0.2rem 0">
            <el-col :span="12" style="color: #67c23a; font-size: 18px">
              本月：{{ monthShowDate }}
            </el-col>
          </el-row>
          <el-table
            :data="monthOrderData"
            size="medium"
            border
            style="width: 100%; margin-top: 0.2rem"
            v-cloak
          >
            <el-table-column label="本月订单" width="200">
              <template slot-scope="scope">
                <span class="font-style">{{ scope.row.month_order_total }}</span>
              </template>
            </el-table-column>
            <el-table-column label="本月合格信息表">
              <template slot-scope="scope">
                <span class="font-style"
                  >本月订单：{{ scope.row.month_info_excel_total.split("/")[0] }}</span
                >
                <br />
                <span class="font-style"
                  >非本月订单：{{ scope.row.month_info_excel_total.split("/")[1] }}</span
                >
                <br />
                <span class="font-style"
                  >总数：{{
                    parseInt(scope.row.month_info_excel_total.split("/")[0]) +
                    parseInt(scope.row.month_info_excel_total.split("/")[1])
                  }}</span
                >
              </template>
            </el-table-column>
            <el-table-column label="本月网报">
              <template slot-scope="scope">
                <span class="font-style"
                  >本月订单：{{ scope.row.month_web_total.split("/")[0] }}</span
                >
                <br />
                <span class="font-style"
                  >非本月订单：{{ scope.row.month_web_total.split("/")[1] }}</span
                >
                <br />
                <span class="font-style"
                  >总数：{{
                    parseInt(scope.row.month_web_total.split("/")[0]) +
                    parseInt(scope.row.month_web_total.split("/")[1])
                  }}</span
                >
              </template>
            </el-table-column>
            <el-table-column label="本月下证">
              <template slot-scope="scope">
                <span class="font-style"
                  >本月订单：{{ scope.row.month_down_cert_total.split("/")[0] }}</span
                >
                <br />
                <span class="font-style"
                  >非本月订单：{{ scope.row.month_down_cert_total.split("/")[1] }}</span
                >
                <br />
                <span class="font-style"
                  >总数：{{
                    parseInt(scope.row.month_down_cert_total.split("/")[0]) +
                    parseInt(scope.row.month_down_cert_total.split("/")[1])
                  }}</span
                >
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <!-- 当前数据统计模块 结束-->
        <!-- 本年统计模块 开始-->
        <el-tab-pane label="年度数据" name="year">
          <el-row :span="24" style="margin: 0.2rem 0">
            <el-col :span="12" style="color: #67c23a; font-size: 18px">
              年份：{{ yearShowDate }}
            </el-col>
          </el-row>
          <el-table
          height="calc(100vh - 266px)"
            :data="yearOrderData"
            size="medium"
            border
            style="width: 100%"
          >
            <el-table-column label="月份" width="200" fixed>
              <template slot-scope="scope">
                <span class="font-style">{{ scope.row.monthly }}</span>
              </template>
            </el-table-column>
            <el-table-column label="本月订单" width="200">
              <template slot-scope="scope">
                <span class="font-style"
                  >本月订单：{{ scope.row.monthly_order_total }}</span
                >
                <!-- <br />
                    <span class="font-style">非本月订单：{{ scope.row.monthly_order_total.split('/')[1]}}</span>
                    <br />
                    <span class="font-style">总数：{{ parseInt(scope.row.monthly_order_total.split('/')[0]) + parseInt(scope.row.monthly_order_total.split('/')[1]) }}</span> -->
              </template>
            </el-table-column>
            <el-table-column label="本月合格信息表" width="200">
              <template slot-scope="scope">
                <span class="font-style"
                  >本月订单：{{ scope.row.monthly_info_excel_total.split("/")[0] }}</span
                >
                <br />
                <span class="font-style"
                  >非本月订单：{{
                    scope.row.monthly_info_excel_total.split("/")[1]
                  }}</span
                >
                <br />
                <span class="font-style"
                  >总数：{{
                    parseInt(scope.row.monthly_info_excel_total.split("/")[0]) +
                    parseInt(scope.row.monthly_info_excel_total.split("/")[1])
                  }}</span
                >
              </template>
            </el-table-column>
            <el-table-column label="本月网报" width="200">
              <template slot-scope="scope">
                <span class="font-style"
                  >本月订单：{{ scope.row.monthly_web_total.split("/")[0] }}</span
                >
                <br />
                <span class="font-style"
                  >非本月订单：{{ scope.row.monthly_web_total.split("/")[1] }}</span
                >
                <br />
                <span class="font-style"
                  >总数：{{
                    parseInt(scope.row.monthly_web_total.split("/")[0]) +
                    parseInt(scope.row.monthly_web_total.split("/")[1])
                  }}</span
                >
              </template>
            </el-table-column>
            <el-table-column label="本月下证" width="auto">
              <template slot-scope="scope">
                <span class="font-style"
                  >本月订单：{{ scope.row.monthly_down_cert_total.split("/")[0] }}</span
                >
                <br />
                <span class="font-style"
                  >非本月订单：{{ scope.row.monthly_down_cert_total.split("/")[1] }}</span
                >
                <br />
                <span class="font-style"
                  >总数：{{
                    parseInt(scope.row.monthly_down_cert_total.split("/")[0]) +
                    parseInt(scope.row.monthly_down_cert_total.split("/")[1])
                  }}</span
                >
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <!-- 本年统计模块 结束-->

        <!-- 汇总数据 开始 -->
        <el-tab-pane label="汇总数据" name="total">
          <el-table
            :data="totalData"
            size="medium"
            border
            style="width: 100%; margin-top: 0.2rem"
            v-cloak
          >
            <el-table-column label="累计订单" width="200">
              <template slot-scope="scope">
                <span class="font-style">{{ scope.row.total_order }}</span>
              </template>
            </el-table-column>
            <el-table-column label="合格信息表">
              <template slot-scope="scope">
                <span class="font-style">{{ scope.row.total_info_excel }}</span>
              </template>
            </el-table-column>
            <el-table-column label="订单网报">
              <template slot-scope="scope">
                <span class="font-style">{{ scope.row.total_web }}</span>
              </template>
            </el-table-column>
            <el-table-column label="下证">
              <template slot-scope="scope">
                <span class="font-style">{{ scope.row.total_down_cert }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <!-- 汇总数据 结束 -->
      </el-tabs>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: "CloudComCount",
  data() {
    return {
      // 选项卡初始化默认值
      activeName: "today",
      searchArr: {
        dateType: "today",
      },
      todayOrderData: [], // 当日
      weekOrderData: [], // 本周
      monthOrderData: [], //本月
      todayShowDate: "", // 当日
      weekShowDate: "", // 本周
      monthShowDate: "", // 本月
      yearShowDate: "",
      yearOrderData: [],
      totalData: [], // 汇总
      // isHeaderFixed: false
    };
  },
  computed: {
    searchStr: function () {
      let str = "";
      for (let key in this.searchArr) {
        str += "&" + key + "=" + this.searchArr[key];
      }
      return str;
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
  methods: {
    getPageData() {
      this.$axios
        .get("/api/admin/tyc_order/cloud_com_count?" + this.searchStr)
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            if (this.searchArr.dateType === "today") {
              this.todayOrderData = data.data.todayOrderData;
              this.weekOrderData = data.data.weekOrderData;
              this.monthOrderData = data.data.monthOrderData;
              this.todayShowDate = data.data.todayShowDate;
              this.weekShowDate = data.data.weekShowDate;
              this.monthShowDate = data.data.monthShowDate;
            } else if (this.searchArr.dateType === "year") {
              this.yearOrderData = data.data.yearOrderData;
              this.yearShowDate = data.data.yearShowDate;
            } else if (this.searchArr.dateType === "total") {
              this.totalData = data.data.totalData;
            }
          }
        });
    },

    // 选项卡默认点击事件
    handleClick(tab, event) {
      // 监听点击事件
      if (parseInt(tab.index) === 0) {
        this.searchArr.dateType = "today";
        this.getPageData();
      } else if (parseInt(tab.index) === 1) {
        this.searchArr.dateType = "year";
        this.getPageData();
      } else if (parseInt(tab.index) === 2) {
        this.searchArr.dateType = "total";
        this.getPageData();
      }
    },

    // handleScroll() {
    //   const tableContainer = this.$el.querySelector('.table-container');
    //   const rect = tableContainer.getBoundingClientRect();
    //   if (rect.top <= 0 && !this.isHeaderFixed) {
    //     this.isHeaderFixed = true;
    //   } else if (rect.top > 0 && this.isHeaderFixed) {
    //     this.isHeaderFixed = false;
    //   }
    // }
  },
  mounted() {
    this.getPageData();
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'


.el-drawer__wrapper >>> .el-drawer
  overflow-y: auto
.el-collapse
  border-bottom 0
  border-top 0
.el-collapse >>> .el-collapse-item__header
  color: #4C87FC
  font-weight bold
.el-collapse >>> .el-collapse-item__arrow
  color: #4C87FC

.cloud-com-count
  marginLeft()
  max-height: 100vh
  .header-style
    z-index: 2
    padding: 0px !important
  .main-style
    z-index: 1
    padding: 0px !important
    overflow-y: auto
  .hide-style
    display: inherit
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
  .tr
    text-align: right
  .mt-10
    margin-top: .2rem
  .font-style
    font-size: 14px
</style>



// WEBPACK FOOTER //
// src/pages/tyc_order/CloudComCount.vue